// File: src/components/serverSetup/ServerSelector.js

import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput } from '@mui/material';

const ServerSelector = ({ guilds, selectedGuild, setSelectedGuild, setGuildId }) => {
  console.log('ServerSelector received guilds:', guilds);
  const handleGuildChange = (event) => {
    const guildId = event.target.value;
    setSelectedGuild(guildId);
    setGuildId(guildId);
  };


  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <InputLabel
        id="server-select-label"
        sx={{
          color: '#A1D1F0',
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        Select a Server
      </InputLabel>
      <Select
        labelId="server-select-label"
        id="server-select"
        value={selectedGuild || ''}
        label="Select a Server"
        onChange={handleGuildChange}
        sx={{
          color: '#9AC0CD',
          backgroundColor: 'rgba(13, 27, 42, 0.8)',
          fontFamily: 'Poppins, sans-serif',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#607080',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#607080',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#081529', // Background color for the dropdown options
              color: '#E0E4ED', // Text color for dropdown options
            },
          },
        }}
      >
        <MenuItem value="">
          <em style={{ color: '#E0E4ED' }}>Select a Server</em>
        </MenuItem>
        {guilds.map((guild) => (
          <MenuItem
            key={guild.id}
            value={guild.id}
            sx={{
              color: '#E0E4ED', // Color for each menu item text
              fontFamily: 'Poppins, sans-serif',
              '&:hover': {
                backgroundColor: '#0D1F3A', // Slightly different background on hover
              },
            }}
          >
            {guild.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ServerSelector;


